import $models from '@/models'
import $store from '@/store'

const $challenge = $models.challenges;
// const $challengeSetting = $models.challengeSettings;
// const $challengeInternal = $models.challengeInternals;
// const $challengeComment = $models.challengeComments;

/* =========================== Helper functions ============================= */

/* ================================ Actions ================================= */

// -----------------------------------------------------------------------------
export function challenge_create({ type, data }) {

  if ( !type ) {
    throw new Error('Invalid type', type)
  }

  /*
  // For now: Create factory for one time use
  const USE_BACKEND = 'REALTIMEDB';
  const backend = backendStoreFactory( USE_BACKEND, 'challenge', {});

  let creatorUserId = rootGetters["user/userAuth"].id;
  // let userData = rootGetters["user/userData"];

  let new_challenge_data = empty_challenge(creatorUserId, type, data, USE_BACKEND);
  let new_challenge_id = util.get_new_uuid();

  return backend.create(new_challenge_data, new_challenge_id).then(() => {
    console.log("challenge created.");
  });
  */

  // return $challenges.add({ type, data })

  let creatorUserId = $store.getters["user/userAuth"].id;
  let new_challenge_data = $challenge.empty({
    type: type,
    user_id: creatorUserId,
    ...data
  })
  return $challenge.add(new_challenge_data, null, { directWrite: true })
}
